<template>
    <div class="fixed bottom-0 w-full">
        <div class="p-5 bg-white w-full border border-t-gray-400">
            <div class="flex w-full justify-between items-center">
                <div class="w-1/3 hidden md:block">
                    <Button v-if="steps.prevStep" :href="prevHref" label="Back" type="secondary"/>
                </div>
                <div class="flex space-x-2 w-1/2 md:w-1/3 md:justify-center">
                    <div v-for="step in steps.allSteps" class="h-2 rounded-full" :class="{ 'bg-regal-blue-700 w-8': step.order == steps.currentStep.order, 'bg-regal-blue-700 w-2': step.order < steps.currentStep.order, 'bg-regal-blue-200 w-2': step.order > steps.currentStep.order }"/>
                </div>
                <div v-if="form" @click="updateModel" class="md:w-1/3 flex justify-end w-1/2">
                    <Button :label="steps.currentStep.label" />
                </div>
                <Link v-else :href="nextHref" method="patch" as="button" class="md:w-1/3 flex justify-end w-1/2">
                    <Button :label="steps.currentStep.label" />
                </Link>
            </div>
        </div>
    </div>
</template>

<script>
import Button from '@/Shared/Button'
import { computed, ref } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'

export default {
    setup(props) {
        const user = computed(() => usePage().props.value.auth.user)
        const account = computed(() => usePage().props.value.auth.account)
        return {
            user,
            account,
        }
    },
    components: { Button },
    props: {
        steps: Object,
        form: Object,
    },
    methods: {
        updateModel() {
            const model = this.steps.currentStep.model == 'user' ? this.user : this.account
            this.form.patch(route(this.steps.currentStep.updateRoute, model))
        }
    },
    computed: {
        prevHref() {
            const model = this.steps.prevStep.model == 'user' ? this.user : this.account
            return route(this.steps.prevStep.route, model)
        },
        nextHref() {
            const model = this.steps.currentStep.model == 'user' ? this.user : this.account
            return route(this.steps.currentStep.updateRoute, model)
        },
    },
}
</script>
